import resolve from 'ioc/resolve'
import { uuid } from 'webutils/services/util';
import $session from 'servicestack/session'


export default class S3Uploader {
    constructor(fnName, file) {
        const me = this;
        const Upload = resolve('Upload');

        me.id = uuid();
        me.fnName = fnName;
        me.file = file;
        me.loaded = 0;
        me.request = {
            url: 'https://emun-on-demand.s3.amazonaws.com/',
            method: 'POST',
            data: {
                key: me.key(),
                AWSAccessKeyId: 'AKIAJZQV2DVWF5ZGFL3A',
                acl: 'private',
                policy: 'ewogICJleHBpcmF0aW9uIjogIjIwMjAtMDEtMDFUMDA6MDA6MDBaIiwKICAiY29uZGl0aW9ucyI6IFsKICAgIHsiYnVja2V0IjogImVtdW4tb24tZGVtYW5kIn0sCiAgICBbInN0YXJ0cy13aXRoIiwgIiRrZXkiLCAiZm4vIl0sCiAgICBbInN0YXJ0cy13aXRoIiwgIiRDb250ZW50LVR5cGUiLCAiIl0sCiAgICB7ImFjbCI6ICJwcml2YXRlIn0sCiAgICBbImNvbnRlbnQtbGVuZ3RoLXJhbmdlIiwgMCwgNTI0Mjg4MDAwXQogIF0KfQ==',
                signature: 'ynaEqdGeMdibiwsF4NSMylXPEY0=',
                'Content-Type': file.type,
                file
            }
        };
        me.upload = Upload.upload(me.request);

        // returns a promise
        me.upload.then(
            res => me.onSuccess(res),
            res => me.onFail(res),
            ev => me.onProgress(ev));
    }

    static map(fnName, $files) {
        let uploaders = $files.map(f => new S3Uploader(fnName, f));
        return {
            all: resolve('$q').all(uploaders.map(u => u.upload)),
            uploaders
        };
    }

    key() {
        const me = this;
        return `fn/${me.fnName}/${$session.clientId}/${me.id}/${me.file.name}`;
    }

    url() {
        const me = this;
        return me.request.url + me.request.data.key;
    }

    onSuccess(response) {
        const me = this;
        me.success = response;
        console.info('S3Uploader success:', me.file.name, response, arguments);
    }

    onProgress(event) {
        const me = this;
        // progress notify
        me.loaded = event.loaded;
        me.total = event.total;
        me.percentage = parseInt(100.0 * event.loaded / event.total);
        me.progress = event;
        console.debug('S3Uploader Progress:', parseInt(100.0 * event.loaded / event.total) + '%', me.file.name);

    }

    onFail(response) {
        const me = this;
        me.failed = response;
        console.error('S3Uploader failed:', response, arguments);
    }
}